import React, { Component } from 'react';
import { connect } from 'react-redux';
import { translate } from '../Services/translation';

import {
    showBahagSignIn,
    forgotPassword
} from "../Actions/Bahag.action"

class BahagConfirmeResetEmail extends Component {
    constructor(props) {
        super(props);

        this.handleResetPassword = this.handleResetPassword.bind(this);
    }
    renderConfirmResetPassword() {
        const email = this.props.resetPasswordEmail;

        return (
            <>
                <h3 id="bahag-signin" className="checkout__section-title">{translate('checkout.bahag.signin.header')}</h3>
                <div className="germany-section__confirm-reset">
                    <span></span>
                    <p className="germany-section__confirm-reset--header">{translate("checkout.bahag.reset.password.confirmation.title")}</p>
                    <p className="germany-section__confirm-reset--subheader">{translate("checkout.bahag.reset.password.confirmation.description")}</p>
                    {email && (<p className="germany-section__confirm-reset--email">{email}</p>)}
                    <div className="germany-section__confirm-reset--buttons">
                        <button onClick={() => this.props.showBahagSignIn()}
                            className="germany-section__signin--buttons--signin"
                            type="submit">{translate('checkout.bahag.confirmation.to.sigin.button')}</button>
                        <a onClick={this.handleResetPassword}>{translate('checkout.bahag.resend.email.forget.password')}</a>
                    </div>
                </div>
            </>
        )
    }

    async handleResetPassword() {
        const email = this.props.resetPasswordEmail;
        if (email) {
            const responseForgetPassword = await this.props.forgotPassword(email);
            if (responseForgetPassword) {
                const responseForgetPasswordCode = responseForgetPassword.Data
                if (responseForgetPasswordCode === 200) {
                    const resetPasswordEmail = this.state.forgetPasswordEmail;
                    if (resetPasswordEmail) {
                        await this.props.setResetPasswordEmail(resetPasswordEmail);
                    }
                    await this.props.showBahagConfirmSentEmail();
                }
            }
        }
    }

    render() {
        return (
            <div>
                {this.renderConfirmResetPassword()}
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => ({
    showBahagSignIn: () => dispatch(showBahagSignIn(true)),
    forgotPassword: (email) => dispatch(forgotPassword(email)),
});

const mapStateToProps = state => {
    return {
        resetPasswordEmail: state.bahag.resetPasswordEmail,
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(BahagConfirmeResetEmail);
